import React, { useState, useEffect } from "react";
import DemoWelcome from "./Components/DemoWelcome";
import Loader from "./Components/Loader";
import ImageSlider from "./Components/ImageSlider";

const DemoPage=()=>{
    return(
        <>
            <DemoWelcome />
            <Loader/>
            <ImageSlider/>
        </>
    );
}

export default DemoPage;